// 及时更新文档：
// https://confluence.zhihuiya.com/pages/viewpage.action?pageId=137986431
import { router } from '@/routers';
import _ from 'lodash';
import { DetailServiceSymbol } from '@/services/DetailService';
import { injectService } from '@/inversify.config';
import { psAxios } from '@patsnap/common-ps-http';
import { rvTrack } from 'track';
import { KNOWN_PLUGIN_NAMES } from './consts';
import { infoStorgeIndexedByPluginName } from './infoSync';
import { Toast } from 'patsnap-biz';
import { i18nSymbol } from '@/i18n';
import { UserService } from '@/domains/user/services/user-service.interface';
const allRegisteredPlugins = new Map();
const allRegisteredRouteNames = new Set();
export class DetailPluginLock {
    static { this.KNOWN_PLUGIN_NAMES = KNOWN_PLUGIN_NAMES; }
    static { this.allRegisteredPlugins = allRegisteredPlugins; }
    static { this.allRegisteredRouteNames = allRegisteredRouteNames; }
    static getAllPluginsSorted() {
        return Array.from(allRegisteredPlugins.values()).sort((a, b) => {
            return a.basicInfo.index - b.basicInfo.index;
        });
    }
    constructor(name) {
        this.PLUGIN_BASIC_PATH = '/detail';
        this._enabled = true;
        this.inited = false;
        // query更新时，不生成新的ReloadIdentifier
        this.silencedUpdateQueryKeys = ['tab'];
        this.name = name;
    }
    static { this.microAppIdPrefix = 'micro-detail-'; }
    get microAppId() {
        return _.kebabCase(`${DetailPluginLock.microAppIdPrefix}${this.name}`);
    }
    _preload() {
        return Promise.resolve();
    }
    get enabled() {
        return this._enabled;
    }
    get isRefineEnabled() {
        return true;
    }
    get _router() {
        return router;
    }
    get pluginRootPath() {
        return `${this.PLUGIN_BASIC_PATH}/${this.name}`;
    }
    get fieldsAndSortsInfo() {
        return infoStorgeIndexedByPluginName.get(this.name);
    }
    get commonProps() {
        return {
            // @ts-ignore todo
            detailPlugin: this,
            pluginRootPath: this.pluginRootPath,
            // @ts-ignore todo
            detailService: injectService(DetailServiceSymbol),
            get locale() {
                const i18n = injectService(i18nSymbol);
                return i18n.locale;
            },
            get psAxios() {
                return psAxios;
            },
            get rvTrack() {
                return rvTrack;
            },
            get timezone() {
                const userService = injectService(UserService);
                return userService.userSetting?.time_zone;
            },
            get uiComponents() {
                return {
                    Toast,
                };
            },
        };
    }
    register() {
        if (!this.enabled) {
            console.debug(`Plugin ${this.name} is disabled, skip registering.`);
            return;
        }
        if (this.inited || allRegisteredPlugins.has(this.name)) {
            throw new Error(`Plugin ${this.name} has already been registered.`);
        }
        // const config = this.getPluginSubRouteConfig();
        // this.validateRouteConfigNames(config, true);
        // this._router.addRoute('detail', config);
        DetailPluginLock.allRegisteredPlugins.set(this.name, this);
        this.inited = true;
        // @ts-ignore
        if (this._preload && typeof window.requestIdleCallback === 'function') {
            // @ts-ignore
            window.requestIdleCallback(() => {
                this._preload();
            });
        }
    }
    // 如果接口发现居然没有，则覆盖路由弹出403
    // Vue-router 4.0 后会有官方的方法
    /*
    public unregister() {
        const noPremConf = {
            path: this.name,
            name: 'detail403Root',
            component: () => import('../../detail-403/Detail403.vue'),
            props: this.commonProps,
        };
        this._router.addRoute('detail', noPremConf);
        this._enabled = false;
        DetailPluginLock.allRegisteredPlugins.delete(this.name);
    }
     */
    validateRouteConfigNames(config, isSubRoot = false) {
        if (!config.name) {
            throw new Error(`Route config name is required: ${config.path}`);
        }
        if (isSubRoot) {
            if (config.path !== this.name) {
                throw new Error(`Top sub route config path must be '${this.name}': but got ${config.path} instead`);
            }
            if (this.basicInfo.key !== this.name) {
                throw new Error(`Plugin key must be the same as plugin name: ${this.name}`);
            }
        }
        if (allRegisteredRouteNames.has(config.name)) {
            throw new Error(`Route name ${config.name} has already been registered.`);
        }
        allRegisteredRouteNames.add(config.name);
        if (config.children) {
            config.children.forEach(child => {
                this.validateRouteConfigNames(child);
            });
        }
    }
    isPathMatched(route = this._router.currentRoute) {
        return route.path.startsWith(this.pluginRootPath);
    }
    // 非必须
    _queryParamsNormalizer(route = this._router.currentRoute) {
        const queryObj = route.query;
        const TAB_DEFAULT = 'folder';
        const { tab = TAB_DEFAULT, spaceId, page = 1, folderId = '', seg = '' } = queryObj;
        const rawp = { spaceId, folderId, page, tab, seg };
        const p = {};
        Object.keys(rawp).forEach(k => {
            if (Array.isArray(rawp[k])) {
                console.error(`Query param ${k} should not be an array: ${rawp[k]}`);
                p[k] = rawp[k][0]; // 参数有可能是数组（不合法），这里只取第一个
            }
            else {
                p[k] = rawp[k];
            }
        });
        return p;
    }
    syncUrlSearchQuery(query = {}, useReplace = false) {
        const action = useReplace ? 'replace' : 'push';
        return this._router[action]({
            path: this._router.currentRoute.path,
            params: this._router.currentRoute.params,
            query: {
                ...this._router.currentRoute.query,
                ...query,
            },
        });
    }
}
export function mapAllPlugins() {
    const requireAll = context => context.keys()
        .map(context);
    const plgs = [
        ...requireAll(require.context('../../', true, /register\.ts/)),
    ].map(item => (_.get(item, 'default.name') ? item.default : item));
    if (plgs.length === 0) {
        throw new Error('No plugins found');
    }
    return plgs;
}
